const ErrorPage = () => {
    return <p>Sorry - this page does not exist</p>
}

export default ErrorPage